import React, { useEffect, useState } from "react";
import {
	Form,
	Button,
	Popconfirm,
	message,
	Modal,
	Spin,
	Switch,
	Table,
	Input,
	Select,
} from "antd";
import {
	useAddVehicleMutation,
	useDeleteVehicleMutation,
	useGetVehiclesQuery,
	useUpdateVehicleMutation,
} from "@/redux/services/vehicleApi";

const VEHICLE_STATUS = [
	{ value: "available", label: "available" },
	{ value: "unavailable", label: "unavailable" },
	{ value: "maintenance", label: "maintenance" },
];

const Add = () => {
	const [form] = Form.useForm();
	const [isOpen, setIsOpen] = useState(false);

	const [addVehicle] = useAddVehicleMutation();
	const { refetch } = useGetVehiclesQuery();

	const onFinish = async (values) => {
		// try {
		// 	await addVehicle({
		// 		...values,
		// 		vehicle_del_flag: false,
		// 	}).unwrap();
		// 	await refetch();
		// 	form.resetFields();
		// 	setIsOpen(false);
		// 	message.success("Create successful");
		// } catch (error) {
		// 	message.error("Something went wrong...");
		// }

		await addVehicle({
			...values,
			vehicle_del_flag: false,
		})
			.unwrap()
			.then((payload) => {
				form.resetFields();
				message.success("Create successful");
				refetch();
				setIsOpen(false);
			})
			.catch((error) => message.error("Something went wrong..."));
	};

	const handleCancel = () => {
		form.resetFields();
		setIsOpen(false);
	};

	return (
		<div>
			<Button
				style={{ marginBottom: "30px" }}
				onClick={() => setIsOpen(true)}
			>
				新车辆
			</Button>
			<Modal
				title="Create A Vehicle"
				open={isOpen}
				onCancel={handleCancel}
				footer={[
					<Button key="cancel" onClick={handleCancel}>
						Cancel
					</Button>,
				]}
				width="60%"
			>
				<Form
					form={form}
					onFinish={onFinish}
					// layout="vertical"
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 16 }}
					style={{ maxWidth: 600, marginTop: "30px" }}
				>
					<Form.Item
						name="vehicle_plate_number"
						label="Plate number"
						rules={[
							{
								required: true,
								message: "请输入车牌号码",
							},
						]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="vehicle_model"
						label="Vehicle model"
						rules={[{ required: true, message: "请输入车型号" }]}
					>
						<Input />
					</Form.Item>

					<Form.Item
						name="vehicle_color"
						label="Color"
						rules={[{ required: true, message: "请输入车辆颜色" }]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="vehicle_total_seats"
						label="Total seats"
						rules={[{ required: true, message: "请输入车总容量" }]}
					>
						<Input type="number" />
					</Form.Item>
					<Form.Item
						name="vehicle_available_seats"
						label="Available seats"
						rules={[
							{ required: true, message: "请输入车空余容量" },
						]}
					>
						<Input type="number" />
					</Form.Item>
					<Form.Item
						name="vehicle_status"
						label="Vehicle status"
						rules={[{ required: true, message: "请选择车状态" }]}
					>
						<Select
							style={{ width: 120 }}
							options={VEHICLE_STATUS}
						/>
					</Form.Item>

					<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
};

const Edit = ({ item, isOpen, handleClose }) => {
	const [form] = Form.useForm();
	const [updateVehicle] = useUpdateVehicleMutation();

	const handleCancel = () => {
		handleClose();
	};

	const onFinish = async (values) => {
		// try {
		// 	await updateVehicle({
		// 		...values,
		// 		vehicle_id: item.vehicle_id,
		// 	}).unwrap();
		// 	message.success("Update successful");
		// 	handleClose();
		// } catch (error) {
		// 	message.error("Something went wrong...");
		// }

		await updateVehicle({
			...values,
			vehicle_id: item.vehicle_id,
		})
			.unwrap()
			.then((payload) => {
				message.success("Update successful");
				handleClose();
			})
			.catch((error) => message.error("Something went wrong..."));
	};

	useEffect(() => {
		form.setFieldsValue(item); // 确保每次 item 更新时，更新表单的字段值
	}, [form, item]);

	return (
		<div>
			<Modal
				title="Edit Vehicle"
				open={isOpen}
				onCancel={handleCancel}
				footer={[
					<Button key="cancel" onClick={handleCancel}>
						Cancel
					</Button>,
				]}
				width="60%"
			>
				<Form
					form={form}
					onFinish={onFinish}
					labelCol={{ span: 8 }}
					wrapperCol={{ span: 16 }}
					style={{ maxWidth: 600, marginTop: "30px" }}
					initialValues={item}
				>
					<Form.Item
						name="vehicle_plate_number"
						label="Plate number"
						rules={[
							{
								required: true,
								message: "请输入车牌号码",
							},
						]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="vehicle_model"
						label="Vehicle model"
						rules={[{ required: true, message: "请输入车型号" }]}
					>
						<Input />
					</Form.Item>

					<Form.Item
						name="vehicle_color"
						label="Color"
						rules={[{ required: true, message: "请输入车辆颜色" }]}
					>
						<Input />
					</Form.Item>
					<Form.Item
						name="vehicle_total_seats"
						label="Total seats"
						rules={[{ required: true, message: "请输入车总容量" }]}
					>
						<Input type="number" />
					</Form.Item>
					<Form.Item
						name="vehicle_available_seats"
						label="Available seats"
						rules={[
							{ required: true, message: "请输入车空余容量" },
						]}
					>
						<Input type="number" />
					</Form.Item>
					<Form.Item
						name="vehicle_status"
						label="Vehicle Status"
						rules={[{ required: true, message: "请选择车状态" }]}
					>
						<Select
							style={{ width: 120 }}
							options={VEHICLE_STATUS}
						/>
					</Form.Item>

					<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
						<Button type="primary" htmlType="submit">
							Submit
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
};

const Vehicle = () => {
	const { data, isLoading, isError, refetch } = useGetVehiclesQuery();
	const [deleteVehicle] = useDeleteVehicleMutation();
	const [isOpenEdit, setIsOpenEdit] = useState(false);
	const [editItem, setEditItem] = useState();

	const handleClose = async () => {
		await refetch();
		setIsOpenEdit(false);
		setEditItem(undefined);
	};

	const handleDelete = async (item) => {
		// try {
		// 	await deleteVehicle(item.vehicle_id);
		// 	message.success(`${item.vehicle_plate_number} delete successful!`);
		// 	refetch();
		// } catch {
		// 	message.error("something went wrong");
		// }

		await deleteVehicle(item.vehicle_id)
			.unwrap()
			.then((payload) => {
				message.success("delete successful");
				refetch();
			})
			.catch((error) => message.error("Something went wrong..."));
	};

	const columns = [
		// {
		// 	title: "ID",
		// 	dataIndex: "vehicle_id",
		// 	key: "vehicle_id",
		// 	editable: true,
		// },
		{
			title: "车牌",
			dataIndex: "vehicle_plate_number",
			key: "vehicle_plate_number",
			editable: true,
		},
		{
			title: "型号",
			dataIndex: "vehicle_model",
			key: "vehicle_model",
			editable: true,
		},
		{
			title: "颜色",
			dataIndex: "vehicle_color",
			key: "vehicle_color",
			editable: true,
		},
		{
			title: "总人数",
			dataIndex: "vehicle_total_seats",
			key: "vehicle_total_seats",
			editable: true,
		},
		{
			title: "可容纳人数",
			dataIndex: "vehicle_available_seats",
			key: "vehicle_available_seats",
			editable: true,
		},
		{
			title: "状态",
			dataIndex: "vehicle_status",
			key: "vehicle_status",
			editable: true,
		},
		{
			title: "修改",
			dataIndex: "",
			key: "x",
			render: (vihecle) => {
				return (
					<Button
						onClick={() => {
							setIsOpenEdit(true);
							setEditItem(vihecle);
						}}
					>
						Edit
					</Button>
				);
			},
		},
		{
			title: "删除",
			dataIndex: "",
			key: "x",
			render: (vihecle) => {
				return (
					<Popconfirm
						title="Delete the vehicle"
						description="Are you sure to delete this vehicle?"
						onConfirm={() => handleDelete(vihecle)}
						okText="Yes"
						cancelText="No"
					>
						<Button danger>Delete</Button>
					</Popconfirm>
				);
			},
		},
	];

	if (isLoading) {
		return <Spin />;
	}

	if (isError) {
		return <div>something went wrong</div>;
	}
	return (
		<div>
			<Add />
			<Table dataSource={data} columns={columns} />
			<Edit
				handleClose={handleClose}
				isOpen={isOpenEdit}
				item={editItem}
			/>
		</div>
	);
};

export default Vehicle;
